<template>
  <!-- 客户分类 -->
  <div class="memClassify">
    <!-- 面包屑导航 -->
    <!-- <page-bar @back="goBack" @refresh="handleRefresh" :title="$route.meta.title"></page-bar> -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >新增客户分类</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>

    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        prop="name"
        show-overflow-tooltip
        label="类型"
      >
      </el-table-column> -->
      <el-table-column
        prop="clienttype"
        align="center"
        show-overflow-tooltip
        label="分类名称"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleCerti(scope.row)"
            >资质管理</el-button
          >
          <el-button
            type="warning"
            @click="handleERP(scope.row)"
            style="padding: 2px 3px"
            plain
            >绑定ERP分类</el-button
          >
          <!-- <el-button
            type="danger"
            @click="deteDel(scope.row)"
            style="padding: 2px 3px"
            plain
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加管理员 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">新增客户分类</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form :model="addForm">
            <el-form
              :model="addForm"
              label-position="rigth"
              label-width="80px"
              ref="addForm"
              :rules="addFormRule"
            >
              <!-- <el-form-item label="类型" prop="type">
                <el-select
                  v-model="addForm.type"
                  placeholder="请选择"
                  clearable
                  style="width: 100%"
                >
                  <el-option label="终端" value="终端"></el-option>
                  <el-option label="连锁" value="连锁"></el-option>
                  <el-option label="批发" value="批发"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="分类名称" prop="name">
                <el-input v-model="addForm.name" clearable></el-input>
              </el-form-item>
            </el-form>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "memClassify",
  data() {
    return {
      /**表格数据 */
      //序号	类型	分类名称	操作
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**新增分类drawer */
      addDrawer: false,
      /**搜索表单 */
      searchForm: {
        name: "",
      },
      /**新增分类表单 */
      addForm: {
        type: "",
        name: "",
      },
      /**新增表格数据 */
      addFormRule: {
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      /**select选中项 */
      selectedList: [],
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**新增分类 */
    handleAdd() {
      this.addDrawer = true;
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetClientType",
        strWhere: this.searchForm.name,
      };
      let proc = "PC_CustomerType"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**删除角色 */
    handleDel() {
      if (this.selectedList.length == 1) {
        // this.$confirm("确定删除吗?", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "error",
        // })
        //   .then(() => {
        let row = this.selectedList[0];
        this.deteDel(row);
        //     })
        //     .catch(() => {});
        // } else {
        //   this.$message({
        //     message: "只能删除一条数据",
        //     type: "warning",
        //   });
      }
    },
    // 删除列表数据
    deteDel(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            type: "DltCustomerType",
            id: row.ID,
          };
          let proc = "PC_CustomerType"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            type: "SaveClientType",
            Clienttype: this.addForm.name,
            name: this.addForm.type,
          };
          let proc = "PC_CustomerType"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
                this.addDrawer = false;
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
                this.addDrawer = false;
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**客户 selection change触发事件 */
    selectionChange(section) {
      this.selectedList = section;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.$refs["addForm"].resetFields();
      this.addDrawer = false;
    },

    /**点击资质管理 */
    handleCerti(row) {
      console.log(row, "12321321");
      let prams = {
        id: row.ID,
        name: row.clienttype,
        typeid: row.TypeID,
      };
      prams = JSON.stringify(prams);
      this.$router.push({
        path: "certificate",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
    // 点击绑定ERP分类

    /**点击资质管理 */
    handleERP(row) {
      console.log(row, "12321321");
      let prams = {
        id: row.ID,
        name: row.clienttype,
        typeid: row.TypeID,
      };
      prams = JSON.stringify(prams);
      this.$router.push({
        path: "eRPCertificate",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
  },
};
</script>

<style scoped>
.memClassify {
  width: 100%;
  height: 100%;
}
</style>
